import {FileFormat} from "enums/index";

export const firefoxCSVMimeType = "application/vnd.ms-excel";

export const mimeType: Record<FileFormat, string> = {
  [FileFormat.CSV]: "text/csv",
  [FileFormat.Excel]: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
}